import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Dialog',
  props: {
  title: {
    type: String,
    required: false,
    default: '',
  },
  text: {
    type: String,
    required: false,
    default: '',
  },
  dialogOpen: {
    type: Boolean,
    required: true,
  },
},
  emits: ['update:dialogOpen'],
  setup(__props, { emit }) {

const props = __props;



// Define emits


// Internal state for dialog (synced with dialogOpen prop)
const internalDialogOpen = ref(props.dialogOpen)

// Watch the dialogOpen prop to keep internal state in sync
watch(
  () => props.dialogOpen,
  (newValue) => {
    internalDialogOpen.value = newValue
  }
)

// Emit changes to the parent when internal state changes
watch(
  () => internalDialogOpen.value,
  (newValue) => {
    emit('update:dialogOpen', newValue)
  }
)

// Close dialog handler
const closeDialog = () => {
  internalDialogOpen.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: internalDialogOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalDialogOpen).value = $event)),
    "max-width": "500"
  }, {
    default: _withCtx(({ activeMain }) => [
      _createVNode(_component_v_card, { class: "mainDialog" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "text", {}, () => [
                _createTextVNode(_toDisplayString(__props.text), 1)
              ])
            ]),
            _: 3
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                text: "",
                onClick: closeDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Close ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})